import { useDisclosure } from '@chakra-ui/react';
import React from 'react';

import Link from 'ui/Link';
import Spinner from 'ui/Spinner';
import Tooltip from 'ui/Tooltip';

import { useSankeyExcelBindingContext } from '../../contexts/sankeyExcelBindingContext';
import ExcelCellsSourceModal from '../ExcelCellsSourceModal';

const DataSourceBindingAddress: React.FC = () => {
  const { bindingAddress } = useSankeyExcelBindingContext();
  const disclosure = useDisclosure();

  return (
    <>
      {bindingAddress ? (
        <Tooltip content="Click here to select new cells as data source">
          <Link onClick={disclosure.onOpen}>{bindingAddress}</Link>
        </Tooltip>
      ) : (
        <Spinner size="xs" ml={1} />
      )}
      <ExcelCellsSourceModal isCreating={false} {...disclosure} />
    </>
  );
};

export default DataSourceBindingAddress;
